import TELink from './TELink';

export default TELink;
